import type { FC, PropsWithChildren } from 'react'
import React, { createContext, useContext } from 'react'

import type { TokenRefreshManager } from '../../utils/tokenRefreshManager'

const TokenRefreshManagerContext = createContext<TokenRefreshManager | null>(null)

export interface TokenRefreshManagerProviderProps extends PropsWithChildren {
    tokenRefreshManager?: TokenRefreshManager
}

export const TokenRefreshManagerProvider: FC<TokenRefreshManagerProviderProps> = ({ children, tokenRefreshManager }) => {
    return <TokenRefreshManagerContext.Provider value={tokenRefreshManager || null}>{children}</TokenRefreshManagerContext.Provider>
}

export const useTokenRefreshManager = () => {
    return useContext(TokenRefreshManagerContext)
}
